import React from 'react'
import { Status, IconButton } from  '../../../components'
import { ingredientStatuses }  from '../../../common/ingredient'
import { compareIds } from '../../../common/utils'
import { DeleteIcon, EditIcon } from '../../../components/icons'
import { cellImageStyle } from '../../../styles/common'

import S from './styled'
const EditButtons = ({ children }) => <S.EditButtons>{children}</S.EditButtons>

export const ingredientColumns = ({ foodKinds }) => [
  {
    name: 'Ingredient Main Image',
    value: item => item.image ? (
      <div style={cellImageStyle(item.image)} alt="Ingredient">
        &nbsp;
      </div>
    ) : <div style={{
      minHeight: '42px',
    }}>&nbsp;</div>,
    noPadding: true,
    center: true,
    style: {
      minWidth: '90px',
    },
  },
  {
    name: 'Unique Ingredient Name',
    value: item => item.name || '-',
    sorted: true,
    sortedFieldName: 'name',
  },
  {
    name: 'Status',
    value: item => (
      <Status
        value={item.ingredientStatus}
        statuses={ingredientStatuses}
        compact
        noActions
      />
    ),
    noPadding: true,
    style: {
      maxWidth: '90px',
    },
    sorted: true,
    sortedFieldName: 'status',
    circularSort: Reflect.ownKeys(ingredientStatuses),
  },
  {
    name: 'Version',
    value: item => item.version || '-',
  },
  {
    name: 'BLS Code',
    value: item => item.blsLink || '-',
  },
  {
    name: 'Category',
    value: item => ((foodKinds || []).find(fk => compareIds(item.foodKindId, fk.id)) || {}).description || item.foodKindId,
    sortedFieldName: 'category',
    sorted: true,
  },
  {
    name: 'Languages',
    value: item => Reflect.ownKeys(item.languages || {})
      .map(lang => item.languages[lang]).filter(Boolean).join(', ') || '-',
  },
]

export default ({ foodKinds, onEdit, handleDelete }) => [
  ...ingredientColumns({ foodKinds }),
  {
    name: '',
    value: item => (
      <EditButtons>
        <IconButton onClick={() => onEdit(item)}><EditIcon /></IconButton>
        <IconButton onClick={() => handleDelete(item)} red><DeleteIcon /></IconButton>
      </EditButtons>
    ),
    style: {
      maxWidth: '60px',
    },
    noPadding: true,
  },
]
